import { ChangeEventHandler, Dispatch, SetStateAction } from "react";
import { EditSvg } from "./svg";
import { useAppStore } from "../../store/store";
import { LuLoader2 } from "react-icons/lu";
import { useClouldinaryUpload } from "../../hooks/cloudinary.hooks";

const ProfileImage = ({
  forProfilePage,
  isForDistributor,
  imagePreviewUrl,
  setImagePreviewUrl,
  setIsImageUploading,
  uploadFolder,
}: {
  forProfilePage?: boolean;
  isForDistributor?: boolean;
  imagePreviewUrl: string;
  setImagePreviewUrl: Dispatch<SetStateAction<string>>;
  setIsImageUploading?: Dispatch<SetStateAction<boolean>>;
  uploadFolder: string;
}) => {
  const userData = useAppStore((state) => state.userData);

  const { upload, isUploading } = useClouldinaryUpload(uploadFolder);

  return (
    <div className="relative w-fit h-fit">
      <div
        className={` ${forProfilePage ? "h-[152px] w-[152px]" : "h-[141px] w-[141px]"} rounded-full overflow-hidden relative`}
      >
        {isForDistributor ? (
          <img
            src={userData.avatar || "/default.png"}
            className="w-full h-full z-[1]"
          />
        ) : (
          <img
            src={imagePreviewUrl || "/default.png"}
            className="w-full h-full z-[1]"
          />
        )}
        {isUploading && (
          <div className="absolute top-0 left-0 bg-black opacity-[0.1] w-full h-full z-[2] rounded-full flex items-center justify-center">
            <LuLoader2 className=" animate-spin text-white text-[80px]" />
          </div>
        )}
      </div>
      <label
        htmlFor="upload-photo"
        className={`!block absolute h-[25px] w-[25px]  ${forProfilePage ? "right-[6px] bottom-[12px]" : "right-[-8px] bottom-[10px]"} z-[5]`}
      >
        <div
          className={`flex items-center justify-center bg-brand-darkYellow rounded-full w-[25px] h-[25px] cursor-pointer  `}
        >
          <EditSvg className="h-[17px] w-[17px] " forProfile={true} />
        </div>
      </label>
      <input
        accept="image/jpeg, image/jpg, image/png"
        type="file"
        name="photo"
        id="upload-photo"
        className="absolute invisible bg-transparent cursor-pointer"
        onChange={async (e) => {
          if (!e.target?.files?.[0]) return;
          setIsImageUploading?.(true);
          const secure_url = await upload(e.target?.files?.[0]);
          setImagePreviewUrl(secure_url);
          setIsImageUploading?.(false);
        }}
      />
    </div>
  );
};

export default ProfileImage;
